<template>
    <div class="auth-wrapper">
        <div class="auth-box">
            <div class="lupus-logo">
                <router-link to="/login" tag="span" class="clickable">
                    <img src="@/../assets/lupus-logo.png" height="80px" alt="Lupus Logo" />
                </router-link>
            </div>
            <div class="title">
                <h4>Passwort zurücksetzen</h4>
            </div>
            <div class="auth-form-container">
                <RepeatPassword v-model="password"></RepeatPassword>
                <div v-if="errors.any()" class="auth-error-message-container">
                    <span>{{ errors.all()[0] }}</span>
                </div>
            </div>
            <div class="auth-button-container">
                <div>
                    <button
                        class="btn btn-primary"
                        :disabled="
                            errors.any() ||
                                !fieldIsDirty('password') ||
                                !fieldIsDirty('repeatpassword')
                        "
                        @click="resetPassword"
                    >
                        Passwort zurücksetzen
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RepeatPassword from "@/components/widgets/RepeatPassword";
export default {
    name: "ResetPassword",
    components: { RepeatPassword },
    data() {
        return {
            password: ""
        };
    },
    mounted() {
        if (this.$route.query.token === null) {
            this.$router.push("/login");
        }
    },
    methods: {
        resetPassword: function() {
            if (this.password === this.repeatPassword) {
                this.$store
                    .dispatch("resetPassword", {
                        token: this.$route.query.token,
                        password: this.password
                    })
                    .then(response => {
                        this.$store
                            .dispatch("LoginFromPasswordReset", response.data.token)
                            .then(() => {
                                this.$router.push("/");
                            });
                    });
            }
        }
    }
};
</script>

<style scoped>
@import "login.css";
</style>
